import { render } from "./PlaceListPage.vue?vue&type=template&id=2c4b0e4a&scoped=true"
import script from "./PlaceListPage.vue?vue&type=script&lang=js"
export * from "./PlaceListPage.vue?vue&type=script&lang=js"

import "./PlaceListPage.vue?vue&type=style&index=0&id=2c4b0e4a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4b0e4a"]])

export default __exports__